/* SISCODE: this store has no customer-facing product detail pages — clicking a product
   card anywhere (image, title, or the empty overlay area) opens the same "Choose Options"
   quick-add popup the "+" button opens, instead of navigating to /products/*.

   IMPORTANT: product pages still exist and stay linked under the hood (product-card.liquid's
   href and the title block's own href are both left completely untouched) because Shopify's
   quick-add modal fetches that page's real HTML in the background to build its variant
   picker/price/form content — removing those links entirely would silently break "Choose
   Options" for every multi-variant product. <product-card> is also given `data-no-navigation`
   (see snippets/product-card.liquid) so product-card.js's own manual navigation for clicks
   that land outside any anchor (e.g. directly on the image) is skipped; this script is what
   turns that now-inert click into a quick-add trigger instead. */
document.addEventListener('click', function (e) {
  var card = e.target.closest('product-card');
  if (!card) return;

  // Let already-interactive elements behave normally: real buttons/inputs (swatches, quantity),
  // and anything inside quick-add-component itself (it handles its own click already).
  if (e.target.closest('button, input, label, select, quick-add-component')) return;

  var quickAddBtn = card.querySelector('quick-add-component .quick-add__button');
  if (!quickAddBtn) return; // no quick-add available (e.g. sold out) - fall back to normal navigation

  e.preventDefault();
  quickAddBtn.click();
});
